import MappingAndonProdDetail from '@/models/MappingAndonProduction/MappingAndonProdDetail';

export default class MappingAndonProdDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.mappingAndonProductionId  = '';
		this.mappingAndonProductionAndonName = '';
		this.machineId  = '';
		this.machineCode = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			mappingAndonProductionId : '0',
			mappingAndonProductionAndonName : '0',
			machineId : '0',
			machineCode : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}